import { combineReducers } from 'redux';
import { IPendingPostPayment } from '../../data/entities/post-payment/index';
import { Actions, ActionTypes } from './actions';

export const pendingPostPaymentData = (state = [], action: Actions = {} as any): IPendingPostPayment[] => {
	switch (action.type) {
		case ActionTypes.POST_PAYMENT_CREATE_QUEUE:
			return [...state, action.payload];
		case ActionTypes.POST_PAYMENT_CREATE_QUEUE_CLEAR:
			return [];
		default:
			return state;
	}
};

export interface IPendingPostPaymentState {
	pendingPostPaymentData: ReturnType<typeof pendingPostPaymentData>;
}

const pendingPostPayments = combineReducers<IPendingPostPaymentState>({
	pendingPostPaymentData
});

export default pendingPostPayments;
